export const DISABLED_INTEGRATIONS_KEY = 'disabled-integrations';
